import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import SinglePropTracker from "../../../../../prop-trackers/single-prop-tracker.js";
import { ValueTracker as ForEachValueTracker } from "../../../../../prop-tracker-utils/for-each.js";

import { EnvLightTypes, Unrecognized } from "../../../../data-defs/envlight-types.js";

const KnownTypes = new Set([Unrecognized].concat(EnvLightTypes));

class EnvLightTypeGen extends ForEachValueTracker {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._pathTracker = new SinglePropTracker();
        this._typeTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._pathTracker.listenNeedsUpdate(needsUpdate);
        this._typeTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(envLightData) {
        this._pathTracker.track(envLightData, envLightData ? this._evtCtx.getEvents(envLightData) : null, "path");
    }

    deleteValue() {
        this._pathTracker.track();
    }

    protected_startUpdate() {
        this._pathTracker.updateIfNeeded(({ prop: { newValue: path } }) => {
            let extension;

            if (typeof path === "string") {
                const extPos = path.lastIndexOf(".")+1;
                extension = path.substring(extPos).toLowerCase();
            }

            if (KnownTypes.has(extension)) {
                this._typeTracker.setValue(extension);
            } else {
                this._typeTracker.deleteValue();
            }
        });

        return this._typeTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._typeTracker.finishUpdate();
    }
}

export default EnvLightTypeGen;
